"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _Card = require("../Card");

var _TextButton = require("../TextButton");

var _CardRowProvider = _interopRequireWildcard(require("./CardRowProvider"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["collapsedLabel", "expandedLabel", "toggleIconLeft", "toggleIconRight"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children", "hideDivider"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledCardRowHeader = (0, _material.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(4)
    },
    alignItems: "center",
    display: "flex",
    padding: theme.spacing(4)
  };
});
var StyledCardRowHeaderColumn = (0, _material.styled)(_material.Box)(function () {
  return {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});

var CardRowExpandToggle = function CardRowExpandToggle(_ref2) {
  var collapsedLabel = _ref2.collapsedLabel,
      expandedLabel = _ref2.expandedLabel,
      toggleIconLeft = _ref2.toggleIconLeft,
      toggleIconRight = _ref2.toggleIconRight,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var ctx = (0, _react.useContext)(_CardRowProvider.CardRowContext);

  if (!ctx) {
    throw new Error("<CardRow.ExpandToggle /> must be used within <CardRow />");
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, _objectSpread({
    iconLeft: ctx.isOpen ? toggleIconLeft === null || toggleIconLeft === void 0 ? void 0 : toggleIconLeft.expanded : toggleIconLeft === null || toggleIconLeft === void 0 ? void 0 : toggleIconLeft.collapsed,
    iconRight: ctx.isOpen ? toggleIconRight === null || toggleIconRight === void 0 ? void 0 : toggleIconRight.expanded : toggleIconRight === null || toggleIconRight === void 0 ? void 0 : toggleIconRight.collapsed,
    label: ctx.isOpen ? expandedLabel : collapsedLabel,
    onClick: function onClick() {
      return ctx.setIsOpen(!ctx.isOpen);
    }
  }, rest));
};

var CardRowHeaderColumn = function CardRowHeaderColumn(_ref3) {
  var children = _ref3.children,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCardRowHeaderColumn, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

var CardRowHeader = function CardRowHeader(_ref4) {
  var children = _ref4.children,
      rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCardRowHeader, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

var CardRowExpandedContent = function CardRowExpandedContent(_ref5) {
  var children = _ref5.children,
      _ref5$hideDivider = _ref5.hideDivider,
      hideDivider = _ref5$hideDivider === void 0 ? false : _ref5$hideDivider,
      rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded4);
  var ctx = (0, _react.useContext)(_CardRowProvider.CardRowContext);

  if (!ctx) {
    throw new Error("<CardRow.ExpandedContent /> must be used within <CardRow />");
  }

  return ctx.isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!hideDivider && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, _objectSpread(_objectSpread({
      p: 4
    }, rest), {}, {
      children: children
    }))]
  }) : null;
};

var CardRow = function CardRow(_ref6) {
  var children = _ref6.children,
      _ref6$isOpenDefault = _ref6.isOpenDefault,
      isOpenDefault = _ref6$isOpenDefault === void 0 ? false : _ref6$isOpenDefault;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardRowProvider.default, {
    isOpenDefault: isOpenDefault,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card, {
      children: children
    })
  });
};

CardRow.Header = CardRowHeader;
CardRow.HeaderColumn = CardRowHeaderColumn;
CardRow.ExpandToggle = CardRowExpandToggle;
CardRow.ExpandedContent = CardRowExpandedContent;
var _default = CardRow;
exports.default = _default;